'use client';
import { env, useRouter } from '@capsicum/common-web';
import { useBrowserTransaction } from '@socios-blk/browser';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const amount = '0.000000000000000001';
const someRecipientAddress = '0xa257f92C721842f0E0E38BCf4ba38Bc9f1216E68';

// A page for making a test transaction. This is meant to help the Finance Feature Team
// test signing on different domains and devices.
// IMPORTANT: This page does NOT belong in production!
// It's exported *conditionally* below for the integration environment only
const TransactionTestingPageComponent = () => {
	const { isPending, sendTransaction, TRANSACTIONS, userOpStatus } = useBrowserTransaction();
	const [status, setStatus] = useState('Waiting for you to press the button');

	const sendChiliz = async () => {
		setStatus('Sending...');

		await sendTransaction({
			transaction: [
				TRANSACTIONS.WITHDRAW_CHZ({
					amount,
					to: someRecipientAddress
				})
			]
		});

		setStatus('Success!');
	};

	return (
		<div>
			<h1>Transaction testing</h1>
			<button disabled={isPending} onClick={sendChiliz}>
				{`Transfer ${amount} CHZ to ${someRecipientAddress}`}
			</button>
			<div>
				Status:
				<S.Output>{status}</S.Output>
			</div>
			<div>
				userOpStatus:
				<S.Output>{JSON.stringify(userOpStatus)}</S.Output>
			</div>
		</div>
	);
};

namespace S {
	export const Output = styled.div`
		background: white;
		border: 1px solid black;
		height: 280px;
		width: 500px;
		overflow-y: scroll;
		overflow-wrap: break-word;
		white-space: pre-wrap;
	`;
}

const NothingToSeeHere = () => {
	const { push } = useRouter();

	useEffect(() => push('/'), []);
};

const isIntegration = env.NEXT_PUBLIC_ENV === 'integration';

// The testing page does NOT belong in production!
// Don't even export it for non-integration builds
export const TransactionTestingPage = isIntegration ? TransactionTestingPageComponent : NothingToSeeHere;
